import type { ControllerLayout } from "./gamepad-mapping";

export interface ControllerArtwork {
  name: string;
  src: string;
  source: string;
  sourceLabel: string;
}

export const CONTROLLER_ARTWORK: Record<ControllerLayout, ControllerArtwork> = {
  "8bitdo-ultimate-2": {
    name: "8BitDo Ultimate 2 Wireless",
    src: "/controllers/8bitdo-ultimate-2-white.png",
    source: "https://www.8bitdo.com/ultimate-2-wireless-controller/",
    sourceLabel: "8BitDo product render",
  },
  "8bitdo-pro-3": {
    name: "8BitDo Pro 3",
    src: "/controllers/8bitdo-pro-3-classic.png",
    source: "https://www.8bitdo.com/pro3/",
    sourceLabel: "8BitDo product render",
  },
  "8bitdo": {
    name: "8BitDo Ultimate family",
    src: "/controllers/8bitdo-ultimate-2-white.png",
    source: "https://www.8bitdo.com/ultimate-2-wireless-controller/",
    sourceLabel: "8BitDo reference render",
  },
  xbox: {
    name: "Xbox Wireless Controller",
    src: "/controllers/xbox-wireless-cutout.png",
    source: "https://www.xbox.com/en-US/accessories/controllers/xbox-wireless-controller",
    sourceLabel: "Xbox product render",
  },
  playstation: {
    name: "DualSense Wireless Controller",
    src: "/controllers/dualsense-white-cutout.png",
    source: "https://www.playstation.com/en-us/accessories/dualsense-wireless-controller/",
    sourceLabel: "PlayStation 360° product frame",
  },
  generic: {
    name: "Generic asymmetric controller",
    src: "/controllers/xbox-wireless-cutout.png",
    source: "https://www.xbox.com/en-US/accessories/controllers/xbox-wireless-controller",
    sourceLabel: "Reference form",
  },
};
